// Generated by ReScript, PLEASE EDIT WITH CARE


function mounted() {
  var self = this ;
  self.wantOpen = self.el.open;
}

function beforeUpdate() {
  var self = this ;
  self.wantOpen = self.el.open;
}

function updated() {
  var self = this ;
  self.el.open = self.wantOpen;
}

var preserveDetailsOpen = {
  mounted: mounted,
  beforeUpdate: beforeUpdate,
  updated: updated
};

export {
  mounted ,
  beforeUpdate ,
  updated ,
  preserveDetailsOpen ,
}
/* mounted Not a pure module */
